import axios from "axios";
import { TrackEventRequest, platformApiApi } from "@capone/platform-api";
import { config } from "../../config";
import { getGlobalTrackingProperties } from "@capone/common";
import { store } from "../../../../../../cap1-application/b2b-base/src/app/store";

export const trackEvent = (req: TrackEventRequest): Promise<boolean> =>
  new Promise(async (resolve, reject) => {
    try {
      req.properties = {
        ...req.properties,
        ...getGlobalTrackingProperties(
          config.TENANT,
          store.getState().rootReducer
        ),
      };

      const res = await platformApiApi(axios).apiV0TrackingEventPost(req, {
        baseURL: config.baseURL,
      });

      resolve(res.data.Response === "Success");
    } catch (e) {
      console.error(e);
      reject(e);
    }
  });
